import type {EmptyObject, Identified, Pageable} from 'src/typings';
import type {LoadListItemsFunction, PageableListSettings} from 'shared/utils/reactive-pageable-list';
import {GenericReactivePageableList} from 'shared/utils/reactive-pageable-list';

export class DefaultReactivePageableList<ITEM extends Identified<ID>, ID> extends GenericReactivePageableList<ITEM, ID, EmptyObject> {
    constructor({
                    loadListItems,
                    loadListSize,
                    pageSize,
                    loadSingleItemFunction
                }: Omit<PageableListSettings<ITEM, ID, EmptyObject>, 'initialParams'>) {
        super({loadListItems, loadListSize, initialParams: {}, pageSize, loadSingleItemFunction});
    }

    public static createWithoutLoadListSizeFunction<ITEM extends Identified<ID>, ID>(settings: Omit<PageableListSettings<ITEM, ID, EmptyObject>, 'initialParams' | 'loadListSize'>): DefaultReactivePageableList<ITEM, ID> {
        let totalSize = Number.MAX_SAFE_INTEGER; // temporary list size until the list is fully loaded
        let list: DefaultReactivePageableList<ITEM, ID> = null; // THIS IS FORWARD REFERENCE OF THE LIST INSTANCE:
        // load function proxy to detect last page load
        const loadListItems: LoadListItemsFunction<ITEM, ID, EmptyObject> = async (pageable: Pageable, params) => {
            const result = await settings.loadListItems(pageable, params);
            if (result.length === 0 || result.length < pageable.pageSize) {
                totalSize = list.loadedSize + result.length;
                await list.loadTotalSize();
            }
            return result;
        };
        const loadListSize = () => Promise.resolve({value: totalSize});

        list = new DefaultReactivePageableList<ITEM, ID>({...settings, loadListItems, loadListSize});
        return list;
    }
}